/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Secondary_Goal_General_HealthInputs */

const en_us2_onboarding_secondary_goal_general_health = /** @type {(inputs: Onboarding_Secondary_Goal_General_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General health`)
};

const pt_br2_onboarding_secondary_goal_general_health = /** @type {(inputs: Onboarding_Secondary_Goal_General_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde geral`)
};

const es_419_onboarding_secondary_goal_general_health = /** @type {(inputs: Onboarding_Secondary_Goal_General_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salud general`)
};

const pt_pt2_onboarding_secondary_goal_general_health = /** @type {(inputs: Onboarding_Secondary_Goal_General_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde geral`)
};

const fr_fr2_onboarding_secondary_goal_general_health = /** @type {(inputs: Onboarding_Secondary_Goal_General_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé générale`)
};

const de_de2_onboarding_secondary_goal_general_health = /** @type {(inputs: Onboarding_Secondary_Goal_General_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Gesundheit`)
};

const it_it2_onboarding_secondary_goal_general_health = /** @type {(inputs: Onboarding_Secondary_Goal_General_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salute generale`)
};

/**
* | output |
* | --- |
* | "General health" |
*
* @param {Onboarding_Secondary_Goal_General_HealthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_secondary_goal_general_health = /** @type {((inputs?: Onboarding_Secondary_Goal_General_HealthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Secondary_Goal_General_HealthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_secondary_goal_general_health(inputs)
	if (locale === "es-419") return es_419_onboarding_secondary_goal_general_health(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_secondary_goal_general_health(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_secondary_goal_general_health(inputs)
	if (locale === "de-DE") return de_de2_onboarding_secondary_goal_general_health(inputs)
	if (locale === "it-IT") return it_it2_onboarding_secondary_goal_general_health(inputs)
	return en_us2_onboarding_secondary_goal_general_health(inputs)
});
export { onboarding_secondary_goal_general_health as "onboarding.secondary_goal.general_health" }